(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-copy-banner"] && !Shopify.designMode) return;
  try {
    
  window.initCopyBanner = function(sectionId) {
    const sectionElement = document.getElementById(sectionId);
    if (!sectionElement) return;

    const copyButton = sectionElement.querySelector('.copy-banner__button');
    if (!copyButton) return;

    const buttonTextElement = copyButton.querySelector('.copy-banner__button-text');
    const originalButtonText = buttonTextElement.innerText;
    const codeToCopy = copyButton.dataset.copyCode;
    const copiedText = copyButton.dataset.copiedText;

    copyButton.addEventListener('click', () => {
      // Verwende die moderne Clipboard-API
      navigator.clipboard.writeText(codeToCopy).then(() => {
        buttonTextElement.innerText = copiedText;
        copyButton.disabled = true;

        setTimeout(() => {
          buttonTextElement.innerText = originalButtonText;
          copyButton.disabled = false;
        }, 2000);
      }).catch(err => {
        console.error('Fehler beim Kopieren des Textes: ', err);
        // Fallback für ältere Browser
        try {
          const textarea = document.createElement('textarea');
          textarea.value = codeToCopy;
          textarea.style.position = 'fixed';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);

          buttonTextElement.innerText = copiedText;
          copyButton.disabled = true;
          setTimeout(() => {
            buttonTextElement.innerText = originalButtonText;
            copyButton.disabled = false;
          }, 2000);
        } catch (error) {
          console.error('Fallback-Kopieren fehlgeschlagen: ', error);
        }
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
